var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRotate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00033 17.3333C4.39783 17.3333 0.666992 13.6025 0.666992 9C0.666992 4.3975 4.39783 0.666668 9.00033 0.666668C13.6028 0.666668 17.3337 4.3975 17.3337 9C17.3337 13.6025 13.6028 17.3333 9.00033 17.3333ZM13.017 13.23C14.0229 12.2766 14.6565 10.9961 14.8042 9.618C14.9519 8.23992 14.6042 6.85425 13.8232 5.70926C13.0422 4.56426 11.8791 3.73475 10.5421 3.36932C9.20518 3.0039 7.7818 3.12644 6.52699 3.715L7.33949 5.1775C7.9736 4.90191 8.66632 4.78844 9.35521 4.84733C10.0441 4.90622 10.7075 5.13561 11.2856 5.51483C11.8638 5.89405 12.3384 6.41117 12.6669 7.01959C12.9953 7.62801 13.1672 8.3086 13.167 9H10.667L13.017 13.23ZM11.4737 14.285L10.6612 12.8225C10.0271 13.0981 9.33433 13.2116 8.64544 13.1527C7.95655 13.0938 7.29314 12.8644 6.71501 12.4852C6.13688 12.106 5.6622 11.5888 5.33377 10.9804C5.00534 10.372 4.83347 9.69141 4.83366 9H7.33366L4.98366 4.77C3.97773 5.72345 3.34415 7.00391 3.19643 8.382C3.0487 9.76009 3.39648 11.1457 4.17746 12.2907C4.95844 13.4357 6.12159 14.2653 7.45853 14.6307C8.79548 14.9961 10.2188 14.8736 11.4737 14.285Z",
    fill: "#2262ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotate);
export default __webpack_public_path__ + "static/media/rotate.f7a239208d1ba3fb41caefb04504e833.svg";
export { ForwardRef as ReactComponent };